import { defineMessage, MessageDescriptor } from "react-intl";

const fillOutRequiredFieldsMessage: MessageDescriptor = defineMessage({
  id: "editActivityModal.header.fillOutRequiredFieldsMessage",
  defaultMessage: "Please fill out required fields to mark this activity as done",
  description: "Alert about filling out required fields",
});

export default fillOutRequiredFieldsMessage;
